import { IConfigContext } from "@app/app/providers/ConfigProvider.tsx";
import { createContext } from "react";

export const ConfigContext = createContext<IConfigContext | null>(null);
